// Карточка сценария (FR-LIB-03): превью стартового кадра, название, ступень, формат, длительность, статус.
import { memo, useMemo } from "react";
import { Board, piecesFromScene, staticPose } from "@brovka/board";
import type { CompiledScenario } from "@brovka/content-types";
import { t } from "../i18n/ru.ts";

export const ScenarioCard = memo(function ScenarioCard({ s, played, onOpen }: { s: CompiledScenario; played: boolean; onOpen: () => void }) {
  const first = s.timelines.main?.steps[0];
  const pose = useMemo(() => staticPose(first?.start ?? {}, first?.ownerStart), [first]);
  const pieces = useMemo(() => piecesFromScene(s.scenario.scene), [s.scenario.scene]);
  return (
    <button className="card scenario-card" onClick={onOpen}>
      <div className="scenario-card__preview" aria-hidden="true">
        <Board field={s.field} pieces={pieces} pose={pose} ariaLabel="" />
      </div>
      <div className="scenario-card__body">
        <strong>{s.scenario.title}</strong>
        <span className="muted">
          {s.field.formatName} · {t.common.minutes(Math.max(1, Math.round((s.scenario.durationSec ?? 60) / 60)))}
        </span>
        <span className={`chip ${played ? "chip--done" : ""}`}>{played ? t.catalog.played : t.catalog.new}</span>
      </div>
    </button>
  );
});
